import React from "react";
import { type DropdownWithoutOptionsProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";

const GroundTransportTypeDropdown = (props: DropdownWithoutOptionsProps<server.dto.GroundTransportType, server.dto.GroundTransportTypes>) => {
  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={serverReference.groundTransportTypes.filter(gt => gt.value !== "unknown")}
    getLabel={p => p.text}
    getValue={(t) => t.value}
    value={props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    config={{
      ...props.config,
      isClearable: true,
    }}
  />;
};

export default GroundTransportTypeDropdown;